import { Box } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const SectionHeader = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
      align-items: center;
    `}
`;

export const SectionTitle = styled(Box)`
  font-size: 20px;
`;

export const HighlightSectionBox = styled(Box)`
  display: none;
  margin-top: 20px;
  align-items: center;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const HighlightSectionIconBox = styled(Box)`
  width: 28px;
  height: 28px;
  margin-right: 10px;
  cursor: pointer;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.blockMenu &&
    css`
      width: 24px;
      height: 24px;
    `}
`;

export const AddBlockButtonBox = styled(Box)`
  position: relative;
  z-index: 1;
  /* Cards already carry a 10px bottom margin, so 30px here read as a 40px break. */
  margin-top: 14px;
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.isAddBlockFixed &&
    css`
      position: fixed;
      width: 600px;
      bottom: 20px;
    `}
}

`;

export const DeleteSectionBox = styled(Box)`
  width: 30px;
  flex: none;
  cursor: pointer;

  ${(props) =>
    props.hide &&
    css`
      visibility: hidden;

      @media (max-width: 568px) {
        display: none;
      }
    `}

  ${(props) =>
    props.subsection &&
    css`
      margin-left: auto;
    `}

  ${(props) =>
    props.blockMenu &&
    css`
      width: 24px;
      height: 24px;
    `}

  ${(props) =>
    props.smallMenu &&
    css`
      width: 18px;
      height: 18px;
    `}
`;

export const SubsectionHeader = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const SectionBodyMenuBox = styled(Box)``;

export const SectionBodyMenuList = styled(Box)`
  display: flex;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isHideTabs &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
  ${(props) =>
    props.noDisplay &&
    css`
      display: none;
    `}
  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
  ${(props) =>
    props.gap &&
    css`
      gap: ${props.gap};
    `}
`;

export const SectionBodyMenuItem = styled(Box).attrs(({ active }) => ({
  'data-active': active ? '' : undefined,
}))`
  margin-right: 10px;
  padding: 12px 30px;
  font-size: 16px;
  cursor: pointer;
  color: var(--main-black);
  line-height: 1.4;
  align-items: center;

  [data-theme='dark'] & {
    color: var(--secondary-gray);
  }

  @media (max-width: 768px) {
    width: 32%;
    padding: 12px 0;
    text-align: center;
  }

  @media (max-width: 576px) {
    margin: 0;
    width: 100%;
  }

  ${(props) =>
    props.isUserMediaLibrary &&
    css`
      padding: 12px 8px;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.center &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isProduct &&
    css`
      padding: 12px 24px;
      font-size: 14px;
    `}

  &[data-active] {
    font-weight: bold;
    color: #fff;
    background: #1c1c1c;
    border-radius: 8px;
  }

  [data-theme='dark'] &[data-active] {
    background: var(--border-light);
    color: var(--main-black);
    border-radius: 6px;
  }
`;

export const SectionBodyList = styled(Box)``;

export const SectionsItem = styled(Box)`
  position: relative;
`;

export const SectionDragIcon = styled.img`
  width: 24px;
  height: 24px;
`;
